import { Component, Input, OnInit } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { TranslateService } from '@ngx-translate/core';
import { ViewStatus } from '@uranda/ui';
import { AdminService } from '../../services/admin.service';
import { Lead, LeadSource } from '../../../../../models/lead.model';
import { Utils } from '../../../../../utils/utils';

@Component({
  selector: 'app-lead-details',
  templateUrl: './lead-details.component.html',
  styleUrls: ['./lead-details.component.css'],
  standalone: false
})
export class LeadDetailsComponent implements OnInit {
  @Input() leadId!: number;
  lead?: Lead;
  viewStatus = ViewStatus.LOADING;

  constructor(
    public activeModal: NgbActiveModal,
    private adminService: AdminService,
    private translateService: TranslateService
  ) { }

  async ngOnInit() {
    await this.loadLeadDetails();
  }

  async loadLeadDetails(): Promise<void> {
    this.viewStatus = ViewStatus.LOADING;
    try {
      const response = await this.adminService.getLeadById(this.leadId);
      this.lead = response;
    } catch (error) {
      console.error('Failed to load lead details:', error);
    }
    this.viewStatus = ViewStatus.READY;
  }

  get formattedLeadType(): string {
    if (!this.lead?.leadType) return '';
    switch (this.lead.leadType) {
      case 'CONTACT_REQUEST':
        return 'Contact Request';
      case 'QUOTE_REQUEST':
        return 'Quote Request';
      default:
        return this.lead.leadType;
    }
  }

  get formattedLeadStatus(): string {
    if (!this.lead?.status) return '';
    switch (this.lead.status) {
      case 'NEW':
        return 'New';
      case 'PROCESSING':
        return 'Processing';
      case 'CONVERTED':
        return 'Converted';
      case 'ARCHIVED':
        return 'Archived';
      case 'SUPPORT':
        return 'Support';
      default:
        return this.lead.status;
    }
  }

  get formattedLeadSource(): string {
    if (!this.lead?.leadSource) return 'Website';
    switch (this.lead.leadSource) {
      case LeadSource.WEBSITE:
        return 'Website';
      case LeadSource.FACEBOOK:
        return 'Facebook';
      default:
        return this.lead.leadSource;
    }
  }

  get leadSourceBadgeClass(): string {
    switch (this.lead?.leadSource) {
      case LeadSource.WEBSITE:
      case undefined:
        return 'bg-primary text-white';
      case LeadSource.FACEBOOK:
        return 'bg-info text-white';
      default:
        return 'bg-secondary text-white';
    }
  }

  get formattedLocation(): string {
    if (!this.lead) return '';
    const country = Utils.resolveCountryName(this.translateService, this.lead.countryCode, this.lead.country);
    return [this.lead.district, this.lead.region, country]
      .filter((part) => part)
      .join(', ');
  }

  get formattedQuoteRequestLocation(): string {
    if (!this.lead) return '';
    return [this.lead.quoteRequestDistrict, this.lead.quoteRequestRegion, this.lead.quoteRequestCountry]
      .filter((part) => part)
      .join(', ');
  }
}
